<template>
  <div class="atomic-video-switcher">
    <video v-lazy-load 
      ref="videoOnRef"
      class="atomic-video-switcher__video atomic-video-switcher__video_active"
      :data-src="videoOnSrc"
      :data-poster="posterOn"
      muted
      preload="auto"
    />

    <video v-lazy-load 
      ref="videoOffRef"
      class="atomic-video-switcher__video"
      :data-src="videoOffSrc"
      :data-poster="posterOff"
      muted
      preload="auto"
    />
  </div>
</template>

<script setup lang="ts">
import { UAParser } from 'ua-parser-js';

interface Props {
  videoOn: string;
  videoOff: string;
  posterOn: string;
  posterOff: string;
}

const props = defineProps<Props>();

const videoOnRef = ref<HTMLVideoElement>();
const videoOffRef = ref<HTMLVideoElement>();

const browserName = UAParser(window?.navigator?.userAgent)?.browser?.name;
const movOnly = browserName === 'Safari' || browserName === 'WebKit';

const videoOnSrc = computed(() => {
  return movOnly ? props.videoOn.replace('.webm', '.mov') : props.videoOn;
});

const videoOffSrc = computed(() => {
  return movOnly ? props.videoOff.replace('.webm', '.mov') : props.videoOff;
});

const playAnimation = (type: 'On' | 'Off') => {
  const activeClass = 'atomic-video-switcher__video_active';
  const videoOn = videoOnRef.value;
  const videoOff = videoOffRef.value;

  if (!videoOn || !videoOff) return;

  if (type === 'On') {
    videoOff.classList.remove(activeClass);
    videoOn.classList.add(activeClass);
    videoOn.currentTime = 0;
    videoOn.play();
  }
  else {
    videoOn.classList.remove(activeClass);
    videoOff.classList.add(activeClass);
    videoOff.currentTime = 0;
    videoOff.play();
  }
};

defineExpose({
  playAnimation,
});
</script>

<style lang="scss" src="~/assets/styles/components/atomic/video-switcher.scss" />
